var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"home"},[_c('home-hero'),_c('info'),_c('registration'),_c('StudentsUnion'),_c('University'),_c('agenda'),_c('trainers'),_c('accommodation'),_c('Coordinator'),_c('partners')],1)}
var staticRenderFns = []

export { render, staticRenderFns }